import { ApolloQueryResult } from '@apollo/client';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  IDataWidgetCustomDasboard,
  IWidgetMetaData,
  IDashboardObject
} from 'src/models/customDashboard';

export type ScreenKey =
  | 'sourceType'
  | 'onmClipping'
  | 'ofmClipping'
  | 'socialMedia'
  | 'group'
  | 'object';

interface IState {
  widgetMetaDataList: ApolloQueryResult<Array<IWidgetMetaData>>;
  widgetDataCustomDashboard: ApolloQueryResult<IDataWidgetCustomDasboard>;
  dashboardList: ApolloQueryResult<Array<IDashboardObject>>;
  dashboardSelectedById: IDashboardObject | null;

  // this states below is used for create custom dashboard
  currentScreen: ScreenKey;
  tempSelectedSocialProfiles: string[];
  tempSelectedKeywords: string[];
}

const initialState: IState = {
  widgetMetaDataList: {
    data: [],
    loading: false,
    errors: [],
    networkStatus: 1,
    partial: false
  },
  dashboardList: {
    data: [],
    loading: false,
    errors: [],
    networkStatus: 1,
    partial: false
  },
  widgetDataCustomDashboard: {
    data: undefined,
    loading: false,
    errors: [],
    networkStatus: 1,
    partial: false
  },
  dashboardSelectedById: null,
  currentScreen: 'sourceType',
  tempSelectedSocialProfiles: [],
  tempSelectedKeywords: []
};

export const customDashboard = createSlice({
  name: 'custom-dasboard',
  initialState,
  reducers: {
    reducerUpdateWidgetMetaDataList: (
      state: IState,
      action: PayloadAction<ApolloQueryResult<Array<IWidgetMetaData>>>
    ) => {
      state.widgetMetaDataList = action.payload;
    },
    reducerUpdateDashboardList: (
      state: IState,
      action: PayloadAction<ApolloQueryResult<Array<IDashboardObject>>>
    ) => {
      state.dashboardList = action.payload;
    },
    reducerUpdateDashboardListAfterDelete: (
      state: IState,
      action: PayloadAction<Array<IDashboardObject>>
    ) => {
      state.dashboardList.data = action.payload;
    },
    reducerUpdateObjectManagementDashboardSelectedById: (
      state: IState,
      action: PayloadAction<IDashboardObject | null>
    ) => {
      state.dashboardSelectedById = action.payload;
    },
    reducerUpdateCurrentScreen: (
      state: IState,
      action: PayloadAction<ScreenKey>
    ) => {
      state.currentScreen = action.payload;
    },
    reducerUpdateTempSelectedSocialProfiles: (
      state: IState,
      action: PayloadAction<string[]>
    ) => {
      state.tempSelectedSocialProfiles = action.payload;
    },
    reducerUpdateTempSelectedKeywords: (
      state: IState,
      action: PayloadAction<string[]>
    ) => {
      state.tempSelectedKeywords = action.payload;
    }
  }
});

export const {
  reducerUpdateWidgetMetaDataList,
  reducerUpdateDashboardList,
  reducerUpdateObjectManagementDashboardSelectedById,
  reducerUpdateDashboardListAfterDelete,
  reducerUpdateCurrentScreen,
  reducerUpdateTempSelectedSocialProfiles,
  reducerUpdateTempSelectedKeywords
} = customDashboard.actions;

export default customDashboard.reducer;
